const NOTIFICATIONS_ERROR_CHANGED = "NOTIFICATIONS_ERROR_CHANGED";
const NOTIFICATIONS_BAR_CLOSED = "NOTIFICATIONS_BAR_CLOSED";
const NOTIFICATIONS_CLOSE_CLICKED = "NOTIFICATIONS_CLOSE_CLICKED";

const NOTIFICATIONS_DIALOG_CLOSE_CLICKED = "NOTIFICATIONS_DIALOG_CLOSE_CLICKED";
const NOTIFICATIONS_SHOW_DIALOG_REQUESTED =
	"NOTIFICATIONS_SHOW_DIALOG_REQUESTED";

const NOTIFICATIONS_UPDATE_AVAILABLE = "NOTIFICATIONS_UPDATE_AVAILABLE";
const NOTIFICATIONS_UPDATE_DISMISSED = "NOTIFICATIONS_UPDATE_DISMISSED";
const NOTIFICATIONS_UPDATE_APPLIED = "NOTIFICATIONS_UPDATE_APPLIED";

export default {
	NOTIFICATIONS_ERROR_CHANGED,
	NOTIFICATIONS_BAR_CLOSED,
	NOTIFICATIONS_CLOSE_CLICKED,
	NOTIFICATIONS_DIALOG_CLOSE_CLICKED,
	NOTIFICATIONS_SHOW_DIALOG_REQUESTED,
	NOTIFICATIONS_UPDATE_AVAILABLE,
	NOTIFICATIONS_UPDATE_DISMISSED,
	NOTIFICATIONS_UPDATE_APPLIED,
};
